import React from 'react';

/**
 * Props for the TablePager component.
 */
interface TablePagerProps {
  pageIndex: number;
  pageCount: number;
  rangeStart: number;
  rangeEnd: number;
  totalItems: number;
  onPrev: () => void;
  onNext: () => void;
}

/**
 * Pagination controls for paged table views: shows the current range and
 * Prev/Next buttons. Renders nothing when there is only a single page.
 */
const TablePager: React.FC<TablePagerProps> = ({
  pageIndex,
  pageCount,
  rangeStart,
  rangeEnd,
  totalItems,
  onPrev,
  onNext,
}) => {
  if (pageCount <= 1) return null;

  return (
    <div className="table-pager">
      <span className="table-pager-range">
        {rangeStart}–{rangeEnd} of {totalItems}
      </span>
      <div className="table-pager-controls">
        <button
          className="table-pager-btn"
          type="button"
          onClick={onPrev}
          disabled={pageIndex === 0}
          aria-label="Previous page"
        >
          ‹ Prev
        </button>
        <span className="table-pager-page">
          Page {pageIndex + 1} of {pageCount}
        </span>
        <button
          className="table-pager-btn"
          type="button"
          onClick={onNext}
          disabled={pageIndex >= pageCount - 1}
          aria-label="Next page"
        >
          Next ›
        </button>
      </div>
    </div>
  );
};

export default TablePager;
